import {
  Component,
  Input,
  ViewChild,
  SimpleChanges,
  OnChanges,
  AfterViewInit,
} from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';
import {
  VisibilityController,
  DefaultVisibilityController,
} from './visibility-controller';
import { UiFactory } from '../../core/ui/ui-factory';
import { PgFieldComponent } from '../pg-field.component';
import { PgInputDirective } from '../pg-input/pg-input.directive';
import { PgSuffixIconsComponent } from '../pg-suffix-icons/pg-suffix-icons.component';
import { Subscription } from 'rxjs';
import { InputModel } from './input-model';
import { BehaviorService } from '../../core/behavior/behavior.service';
import { FactoryFormControlBuilder } from './factory-form-control-builder';
import { TextMasks } from '../../core/text/masks';
import { IconModel } from '../../pg-icon/icon-model';

@Component({
  selector: 'pg-input-factory, grit-input-factory',
  templateUrl: './pg-input-factory.component.html',
  styleUrls: ['./pg-input-factory.component.scss'],
  providers: [
    {
      provide: VisibilityController,
      useClass: DefaultVisibilityController,
    },
  ],
})
export class PgInputFactoryComponent extends UiFactory
  implements OnChanges, AfterViewInit {
  @Input()
  parentFormGroup: FormGroup;
  @Input() visibilityController: VisibilityController;
  @ViewChild(PgFieldComponent)
  field: PgFieldComponent;
  @ViewChild(PgInputDirective)
  input: PgInputDirective;

  willRender = true;

  @ViewChild(PgSuffixIconsComponent) suffixIconsChild: PgSuffixIconsComponent;

  get control(): AbstractControl {
    return this.parentFormGroup.controls[this.inputModel.formControlName];
  }

  validCharactersSubscription: Subscription;

  @Input('model')
  model: any;

  mask: any = false;
  get inputModel(): InputModel {
    return this.model;
  }

  constructor(
    // public evaluator: StatementEvaluatorService,
    // private _validation: ValidationService,
    // private _formBuilder: FormBuilder,
    defaultVisibilityController: VisibilityController,
    private _behaviorService: BehaviorService,
    // private _triggerService: TriggerService,
    private factoryFormBuilder: FactoryFormControlBuilder
  ) {
    super(_behaviorService);
    if (!this.visibilityController) {
      this.visibilityController = defaultVisibilityController;
    }
  }

  ngOnInit() {
    super.ngOnInit();

    if (this.inputModel.shouldRender) {
      this.behaviorService
        .execute(this.inputModel.shouldRender, {
          target: this,
          formGroup: this.parentFormGroup,
        })
        .then(result => {
          if (!result) {
            // unregister stuff
            this.willRender = false;
            this.parentFormGroup.removeControl(this.inputModel.formControlName);
          }
        });
    }

    this.factoryFormBuilder.buildFormWithModel(
      this.parentFormGroup,
      this.inputModel.formControlName,
      this.inputModel.validationList,
      this.inputModel.required
    );
    this._buildFormMask();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.model && !changes.model.firstChange) {
      // Check for changes in validation list because we will have to re-build form validators
      const prev: InputModel = changes.model.previousValue || {};
      const next: InputModel = changes.model.currentValue || {};
      const prevValidationList = prev.validationList || [];
      const nextValidationList = prev.validationList || [];
      const difference = prevValidationList.filter(
        x => !nextValidationList.find(i => i.errorKey === x.errorKey)
      );
      if (difference || difference.length) {
        this.factoryFormBuilder.buildFormWithModel(
          this.parentFormGroup,
          this.inputModel.formControlName,
          this.inputModel.validationList,
          this.inputModel.required
        );
      }

      this._buildFormMask();
    }
  }

  ngAfterViewInit() {
    // this.input.stateChanges
    //   .pipe(
    //     mergeMap(async () => {
    //       await this._triggerService.checkAndRunTriggers(
    //         this.inputModel.triggers,
    //         {
    //           target: this,
    //           targetModel: this.inputModel,
    //           value: this.input.value,
    //           formGroup: this.parentFormGroup,
    //         }
    //       );
    //     })
    //   )
    //   .subscribe();
  }

  getMask() {
    let mask: any = false;
    const placeholderChar = '\u2000';
    if (
      this.inputModel.visibilityCanToggle &&
      !this.visibilityController.isFieldVisible
    ) {
      // No op
    } else if (this.inputModel.mask) {
      if (typeof this.inputModel.mask === 'string') {
        mask = TextMasks[this.inputModel.mask];
      } else {
        mask = this.inputModel.mask.map(char => {
          if (typeof char === 'string') {
            return char;
          } else {
            return new RegExp(char.regex);
          }
        });
      }
    }

    return {
      mask: mask,
      keepCharPositions: true,
      placeholderChar: placeholderChar,
    };
  }

  getInputType() {
    if (
      this.inputModel.visibilityCanToggle &&
      this.visibilityController &&
      !this.visibilityController.isFieldVisible
    ) {
      return 'password';
    }
    if (this.inputModel && this.inputModel.type) {
      return this.inputModel.type;
    }
    return 'text';
  }

  handleFieldInput(event: Event) {
    this.visibilityController.handleUserInput(<any>event);
  }

  getMaxLength() {
    if (this.inputModel.maxLength) {
      return this.inputModel.maxLength;
    }
    return null;
  }

  isIconVisible(icon: IconModel) {
    return !!!icon.hidden;
    // if (!icon.predicate) {
    //   return !!!icon.hidden;
    // }
    // let context = {
    //   isHovered: false,
    //   isFocused: false,
    //   isTouched: false,
    //   isError: false,
    //   isComplete: false,
    //   form: {},
    // };
    // if (this.input) {
    //   context = {
    //     isHovered: this.field._classIsHovered,
    //     isFocused: this.input.isFocused,
    //     isTouched: this.input.ngControl.touched,
    //     isError: this.input.isError,
    //     isComplete: this.field._classIsComplete,
    //     form: { ...this.parentFormGroup.value },
    //   };
    // }

    // return this.evaluator.evaluatePredicate(icon.predicate, context);
  }

  handleSuffixIconClicked(event: Event, icon: IconModel) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();
    if (icon.onClick && icon.onClick.length) {
      this._behaviorService.execute(icon.onClick, {
        target: this,
        formGroup: this.parentFormGroup,
        iconModel: icon,
      });
    }
  }

  handleBehaviorEvent(eventName, event: Event) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();
    if (this.inputModel[eventName] && this.inputModel[eventName].length) {
      this._behaviorService.execute(this.inputModel[eventName], {
        target: this,
        targetModel: this.inputModel,
        value: this.input.value,
        formGroup: this.parentFormGroup,
      });
    }
    // TODO: dont forget to set up handlers for behavior events.
  }

  private _buildFormMask() {
    // TODO: use the valid characters here to subscribe to form value changes
    if (
      this.validCharactersSubscription &&
      !this.validCharactersSubscription.closed
    ) {
      this.validCharactersSubscription.unsubscribe();
    }
    if (this.inputModel.validCharacters) {
      this.validCharactersSubscription = this.control.valueChanges.subscribe(
        (val: string) => {
          if (!val) {
            return;
          }
          let changed = null;
          const regex = new RegExp(`[^${this.inputModel.validCharacters}]`);
          if (regex.test(val)) {
            const replRegex = new RegExp(regex, 'g');
            changed = val.replace(replRegex, '');
            this.control.setValue(changed);
          }
        }
      );
    }
  }
}
